import { Injectable, APP_INITIALIZER } from '@angular/core';

import { User, newUser } from './user';
import { MessageService } from '../messages/message.service';
import { DataService } from '../data.service';
import { AuthorizationService } from '../authorization.service';
import { Router } from '@angular/router';
import { Idle } from '@ng-idle/core';
//import { PublicClientApplication } from '@azure/msal-browser';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
//   config = {
//     auth: {
// //      clientId: "2b8c29d4-8b39-406c-9336-13fe64e53c13", //Richard's ST 
//       clientId:  "5fa7c139-9764-4f7f-8fa8-9d2007015046", // DIT's ST
// //      authority: "https://login.microsoftonline.com/e973f68d-13e9-4a35-b0de-b76c438a89ba", // Richard's ST
//       authority: "https://login.microsoftonline.com/7a7681dc-b9d0-449a-85c3-ecc26cd7ed19",  // DIT's ST
//       redirectUri: "/", //defaults to application start page
//       postLogoutRedirectUri: "/",
//     },
//   };

  redirectUrl: string;
  
  get currentUser(): User{
    let _currentUser=JSON.parse(sessionStorage.getItem('currentUser'));
    return _currentUser;
  }

  set currentUser(value){
    sessionStorage.setItem('currentUser',JSON.stringify(value));
  }
  
  get isLoggedIn():boolean {
    return !!this.currentUser;
  } 

  get isCoordinator(): boolean {
    if (!this.currentUser)
      return false;
    return this.currentUser['permLevel']==2;
  }

  get isBlncAdmin(): boolean {
    if (!this.currentUser)
      return false;
    return this.currentUser['permLevel']==3;
  }

  get isLeadAdmin(): boolean {
    if (!this.currentUser)
      return false;
    return this.currentUser['permLevel']==4;
  }

  constructor(private messageService: MessageService, private dataService: DataService, 
              public authorizationService: AuthorizationService, private router: Router, private idle: Idle) {  }

  logout(): void {
    this.idle.stop();  
    this.dataService.clearCache();
    sessionStorage.removeItem("currentUser");
    this.redirectUrl='/';
    this.authorizationService.signOut();
//    let tenantId=this.config.auth.authority.slice(this.config.auth.authority.length-36);
//    window.location.href = '/'; //`https://login.microsoftonline.com/${tenantId}/oauth2/logout?post_logout_redirect_uri=${window.location.origin}`;
  }

  // azureLogin(): void {  
  //   this.authorizationService.authorize();
//    return;  
//     const loginRequest = {scopes: []}
//     const myMsal = new PublicClientApplication(this.config);
//     console.log(this.config);
//     myMsal.loginPopup(loginRequest)
//       .then((loginResponse)=> {
//           let userName=loginResponse.account.username;
//           userName=userName.slice(0,userName.indexOf('@'));
//           let u=newUser();
//           u.token=loginResponse.accessToken;
//           sessionStorage.setItem("currentUser", JSON.stringify(u));
// //          console.log(this.currentUser);
//           this.login(userName, ''); 
// //          console.log(loginResponse);
// //          console.log(u);
//       });
//  }

  login(userName: string, password: string): void {
    this.dataService.login(userName, password).subscribe((data: User)=>{
      if  (data['error']){
        alert(data['error']);
        return;
      }
      this.idle.watch();
      let currentUser=data;
//      console.log(data);
      sessionStorage.setItem("currentUser", JSON.stringify(currentUser));   
      this.dataService.clearCache();
      console.log(this.redirectUrl);
      if (currentUser.permLevel==2 && currentUser.updatedDate< this.getFilterDate()) {
        this.router.navigate(['/user',currentUser.id,'edit']);
      }
      else if (this.redirectUrl) {
        this.router.navigateByUrl(this.redirectUrl);
      }
      else {
        this.router.navigateByUrl('/');
      }
    });
  }

  getFilterDate(){
        let d=new Date();
        let e=new Date(d.getFullYear(),d.getMonth()-10,d.getDate(),0,0,0,0);
        return e.toISOString();  
  }     
}
  
